import {Injectable} from '@angular/core';
import {User} from './user.model';
import {Observable} from 'rxjs/Observable';
import {CrudService} from '@ngx-ivengi/crud';
import {AuthenticationService} from '@ngx-ivengi/authentication';
import {HttpClient} from '@angular/common/http';
import {CrudInteractionService, CrudConfig} from '@ngx-ivengi/crud';

@Injectable()
export class UserService extends CrudService<User> {
  public entityType = User;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user.service.ts